/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  continue: 'continue',
  select_date: 'select_date',
  selected: 'selected',
  perAdult: 'perAdult',
  from: 'from',
  totalPriceFrom: 'totalPriceFrom',
  priceInfo: 'priceInfo'
}; export default Keys;